"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLunchItems = exports.isLunchListItemVisible = exports.isPlaylistItemVisibleBySchedule = exports.isPlaylistItemVisibleByConditions = exports.isPlaylistItemVisibleByPriority = exports.isVisibleByPlaylistRange = exports.isPlaylistItemVisibleByWeather = void 0;
const playlists_1 = require("../types/playlists");
const channels_1 = require("../types/channels");
const date_1 = require("./date");
const schedule_1 = require("./schedule");
/** Get Lunch items for current day */
const getLunchItems = (item, currentTimeMs) => {
    if ((playlists_1.isListPlaylistItemPlayer(item) || playlists_1.isListPlaylistItemPreviewPlayer(item)) &&
        item.lunchListItems) {
        const dateNow = new Date(currentTimeMs);
        const todaysItems = item.lunchListItems.find(({ date }) => date_1.isSameDay(dateNow, new Date(date)));
        return todaysItems && todaysItems.lunchItems.length > 0 ? todaysItems.lunchItems : undefined;
    }
    return undefined;
};
exports.getLunchItems = getLunchItems;
/**
 * Lunch list item is visible only if it contains lunchItems for today.
 * @param item
 */
const isLunchListItemVisible = (item, currentTimeMs) => {
    return (playlists_1.isListPlaylistItemPlayer(item) || playlists_1.isListPlaylistItemPreviewPlayer(item)) &&
        getLunchItems(item, currentTimeMs)
        ? true
        : false;
};
exports.isLunchListItemVisible = isLunchListItemVisible;
const isTemperatureValid = (currentTemperatureString, temperatures) => {
    if (currentTemperatureString === undefined ||
        temperatures === undefined ||
        temperatures.length === 0) {
        return true;
    }
    const temperature = parseInt(currentTemperatureString, 10);
    return temperatures.some(({ tempLow, tempHigh }) => temperature >= tempLow && temperature <= tempHigh);
};
// Possible weather types: cloud, rain, snow, sun
const isWeatherTypeValid = (currentWeatherType, weatherCondition) => {
    if (currentWeatherType === undefined) {
        return true;
    }
    const isWeatherTypeCorrect = weatherCondition
        ? weatherCondition[currentWeatherType]
        : false;
    return isWeatherTypeCorrect || false;
};
/**
 * Check if current time matches to playlist item schedule
 */
const isPlaylistItemVisibleByWeather = (currentWeather, weatherCondition) => {
    if (weatherCondition && (weatherCondition.temperatures || weatherCondition.condition)) {
        const currentTemperatureString = currentWeather === null || currentWeather === void 0 ? void 0 : currentWeather.temperature;
        const currentWeatherType = currentWeather === null || currentWeather === void 0 ? void 0 : currentWeather.weatherCondition;
        if (currentTemperatureString && currentWeatherType) {
            const isTempValid = isTemperatureValid(currentTemperatureString, weatherCondition.temperatures);
            const isWeatherValid = isWeatherTypeValid(currentWeatherType, weatherCondition.condition);
            return isTempValid && isWeatherValid;
        }
        // if current weather information does not exist
        return false;
    }
    // if none conditions are set
    return true;
};
exports.isPlaylistItemVisibleByWeather = isPlaylistItemVisibleByWeather;
/**
 * @summary Validate will item be visible by comparing it's priority to other item priorities.
 *  - e.g if currentItem's priority is 1 (low) and another item with priority 2 (medium is found),
 * check if priority 2 item  is visible at the same time. If it is returns false for function.
 * @example
 * const item = { ...PlaylistItemPlayer, priority: 1 }
 * const allItems = [item, {...PlaylistItemPlayer, priority: 2}]
 * const isVisible = isPlaylistItemVisibleByPriority(item, allItems)
 * // => false
 * @param item current playlist item
 * @param allItems all playlist items for screen (linked playlist and channel)
 * @param currentTimeMs
 */
const isPlaylistItemVisibleByPriority = (item, allItems, currentTimeMs) => !allItems.some(playlistItem => {
    // if a channel item has a greated priority than current item
    // check if item is visible at the moment, if true current item will not be played.
    if ((item.priority || channels_1.ChannelItemPriority.low) <
        (playlistItem.priority || channels_1.ChannelItemPriority.low)) {
        return isPlaylistItemVisibleBySchedule(playlistItem, currentTimeMs);
    }
    return false;
});
exports.isPlaylistItemVisibleByPriority = isPlaylistItemVisibleByPriority;
/**
 * Check if item is visible by ChannelItem ranges.
 */
const isVisibleByPlaylistRange = ({ playlistStartDate, playlistEndDate, playlistStartTime, playlistEndTime }, currentTimeMs) => {
    if (playlistStartDate !== undefined && playlistEndDate !== undefined) {
        const start = new Date(playlistStartDate);
        const end = schedule_1.getEndDateFromIsoDateString(playlistEndDate);
        const currentDate = new Date(currentTimeMs);
        const isInRange = currentDate >= start && currentDate <= end;
        // date range matches, check for startTime and endTime match
        if (isInRange && playlistStartTime && playlistEndTime) {
            const startTimeMs = date_1.getCurrentMsByTime(currentTimeMs, new Date(playlistStartTime));
            const endTimeMs = date_1.getCurrentMsByEndTime(currentTimeMs, new Date(playlistEndTime));
            return currentTimeMs <= endTimeMs && currentTimeMs >= startTimeMs;
        }
        return isInRange;
    }
    return true;
};
exports.isVisibleByPlaylistRange = isVisibleByPlaylistRange;
/**
 * Check if current time matches to playlist item schedule
 */
const isPlaylistItemVisibleBySchedule = (item, currentTimeMs) => {
    // Check if playlist item is not visible by channel playlist's item
    if (isVisibleByPlaylistRange(item, currentTimeMs) === false) {
        return false;
    }
    if (item.schedule === undefined) {
        return true;
    }
    const { schedule } = item;
    const ranges = playlists_1.isLegacySchedule(schedule)
        ? schedule_1.convertLegacySchedule(schedule).ranges
        : schedule.ranges;
    if (ranges.length > 0) {
        const currentDay = date_1.getCurrentDayLong(currentTimeMs);
        const match = ranges.find(({ start, end, conditions }) => {
            const startD = schedule_1.getDateFromScheduleDateTime(start).getTime();
            const endD = schedule_1.getEndDateFromScheduleDateTime(end).getTime();
            if (currentTimeMs <= endD && currentTimeMs >= startD) {
                if (conditions === null || conditions === undefined || (conditions === null || conditions === void 0 ? void 0 : conditions.length) === 0) {
                    return true;
                }
                const matchConditions = conditions.find(({ startTime, endTime, days }) => {
                    const isDayVisible = days ? days[currentDay] : false;
                    if (isDayVisible) {
                        const startTimeMs = date_1.getCurrentMsByTime(currentTimeMs, schedule_1.getDateFromScheduleTime(startTime));
                        const endTimeMs = date_1.getCurrentMsByEndTime(currentTimeMs, schedule_1.getDateFromScheduleTime(endTime));
                        if (currentTimeMs <= endTimeMs && currentTimeMs >= startTimeMs) {
                            return true;
                        }
                    }
                    return false;
                });
                if (matchConditions) {
                    return true;
                }
            }
            return false;
        });
        if (match) {
            return true;
        }
        return false;
    }
    return true;
};
exports.isPlaylistItemVisibleBySchedule = isPlaylistItemVisibleBySchedule;
/**
 * Check if playlist item is visible by schedule and weather.
 * If lunch list item, also check if any lunch list items are visible for today
 */
const isPlaylistItemVisibleByConditions = ({ item, allItems, screenHasChannels, currentWeather, currentTimeMs }) => {
    var _a;
    const weatherCondition = (_a = item.conditions) === null || _a === void 0 ? void 0 : _a.weather;
    const isLunchListItem = (playlists_1.isListPlaylistItemPlayer(item) || playlists_1.isListPlaylistItemPreviewPlayer(item)) && item.lunchListItems
        ? true
        : false;
    if (!isPlaylistItemVisibleBySchedule(item, currentTimeMs)) {
        return false;
    }
    const isWeatherOk = currentWeather
        ? isPlaylistItemVisibleByWeather(currentWeather, weatherCondition)
        : true;
    if (!isWeatherOk) {
        return false;
    }
    // Validate priorities only if screen has channel linked to it
    const isPriorityOk = screenHasChannels
        ? isPlaylistItemVisibleByPriority(item, allItems, currentTimeMs)
        : true;
    return isLunchListItem
        ? isPriorityOk && isLunchListItemVisible(item, currentTimeMs)
        : isPriorityOk;
};
exports.isPlaylistItemVisibleByConditions = isPlaylistItemVisibleByConditions;
//# sourceMappingURL=playlistConditions.js.map